const WEB_PROTOCOLS = ['//', 'http:', 'https:', 'ftp:', 'file:'];

export const getIsInternalUrl = url => !WEB_PROTOCOLS.find(protocol => url.startsWith(protocol));
export const getIsExternalUrl = url => !getIsInternalUrl(url);
